import React from 'react';

interface IProps {
  description: string;
  classname?: string;
}

export const DescriptionBlock: React.FC<IProps> = (props) => {
  const { description, classname } = props;

  return (
    <div className={classname}>
      <span>{description}</span>
    </div>
  );
};
